import { TALENT_ID } from '../ids/talent-id'
import { TalentMap } from 'web/data/models'
import { SPEC_ID } from '../ids/spec-ids'

export const PRIEST_TALENTS: TalentMap = {

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Holy Priest
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [TALENT_ID.PRIEST.HOLY.SALVATION]: {
        id: TALENT_ID.PRIEST.HOLY.SALVATION,
        specId: SPEC_ID.PRIEST.HOLY,

        name: "Holy Word: Salvation",
        shortName: "Salv",

        game_id: 265202,
        icon_name: "ability_priest_archangel"
    },

    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#
    //
    // Disc Priest
    //
    // #-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#

    [TALENT_ID.PRIEST.DISC.EVANGELISM]: {
        id: TALENT_ID.PRIEST.DISC.EVANGELISM,
        specId: SPEC_ID.PRIEST.DISC,

        name: "Evangelism",
        shortName: "Evang",

        game_id: 246287,
        icon_name: "spell_holy_divineillumination",
    },

    [TALENT_ID.PRIEST.DISC.MINDBENDER]: {
        id: TALENT_ID.PRIEST.DISC.MINDBENDER,
        specId: SPEC_ID.PRIEST.DISC,

        name: "Mindbender",
        shortName: "Mind",

        game_id: 123040,
        icon_name: "spell_shadow_soulleech_3",
    },

}
